export default "__VITE_ASSET__f9442f73__"